module.exports = __webpack_public_path__ + "img/button3.04d794e8.png";